// src/components/auth/RequireAuth.js

import React, {
  useContext,
} from "react";

import {
  Navigate,
  useLocation,
} from "react-router-dom";

import {
  AuthContext,
} from "../../context/AuthContext";

export default function RequireAuth({
  children,
  role,
}) {
  const {
    user,
    loading,
    hasRole,
  } = useContext(AuthContext);

  const location =
    useLocation();

  if (loading) {
    return (
      <div
        style={{
          padding: 16,
          textAlign:
            "center",
        }}
      >
        Cargando...
      </div>
    );
  }

  if (!user) {
    return (
      <Navigate
        to="/login"
        replace
        state={{
          from:
            location,
        }}
      />
    );
  }

  if (
    role &&
    !hasRole(role)
  ) {
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: location, requiredRole: role }}
      />
    );
  }

  return children;
}
